// extracted by mini-css-extract-plugin
export var logo = "_4w-2";
export var logoWrapper = "_4w-1";
export var strip = "_4w-0";